import 'es6-promise/auto';

import Vue from 'vue';
import Vuex from 'vuex';
import anime from 'animejs';
import debounce from 'lodash/debounce';
const imagesLoaded = require('imagesloaded');
import { expandCover, closeCover, stopMusic, startMusic, enterCover, leaveCover } from './pp';
import { disableTouchMove, isMobile } from './utils';
import data from './json/data.json';
// import data from './json/data_staging.json';


export default new Vuex.Store({
  state: {
    playsinline: true,
    showPressDate: false,
    scrolled: false,
    touchAllowed: false,
    menuAllowed: false,
    sliderBulletsAllowed: false,
    audioPlaying: false,
    openBox: false,
    contentTrigger: false,
    contentActive: false,
    nextPrevSectionClick: 0,
    interactionReady: false,
    data: data,
    timing: {
      contentTiming: 300,
      sectionTiming: 600,
      touchController: 400,
      touchThreshold: 100,
      resize: 100,
      animeOffset: '0',
      playButton: 200,
      closeContentDelay: 1200,
      closeActionDelay: 1000,
    },
    strokeStatus: false,
    subContentActive: false,
    subContentMoveLeft: 0,
    closeContentActive: false,
    subContentVideoPlay: false,
    siteContainerValues: {
      offset: 0,
      currentSection: 0,
    },
    subContentContainerValues: {
      offset: 0,
      currentSlide: 0,
    },
    showSubContent: -1,
    menuActive: false,
    rotateValue: 90,
    bgValue: 0,
    s0: 0,
    s1: 0,
    s2: 0,
    s3: 0,
    s4: 0,
    s5: 0,
    s6: 0,
    size: {
      isDesktop: null,
      isTablet: null,
      isMobile: null,
    },
    baseFontSize: null,
  },
  mutations: {
    sectionClick(state, status) {
      switch (status) {
        case 'next':
          state.nextPrevSectionClick += 1;
          break;
        case 'prev':
          state.nextPrevSectionClick -= 1;
          break;
        case 'reset':
          state.nextPrevSectionClick = 0;
          break;
        default:
          state.nextPrevSectionClick += 1;
          break;
      }
    },
    interactionReady(state, value) {
      state.interactionReady = value;
    },
    sectionClickValue(state, value) {
      state.nextPrevSectionClick = value;
    },
    strokeStatus(state, value) {
      state.strokeStatus = value;
    },
    audioPlaying(state, value) {
      state.audioPlaying = value;
    },
    sliderBulletsAllowed(state, value) {
      state.sliderBulletsAllowed = value;
    },
    menuAllowed(state, value) {
      state.menuAllowed = value;
    },
    touchAllowed(state, value) {
      state.touchAllowed = value;
    },
    scrolled(state, value) {
      state.scrolled = value;
    },
    showPressDate(state, value) {
      state.showPressDate = value;
    },
    checkMobileVideo(state, value) {
      state.playsinline = value;
    },
    subContentVideoPlay(state, value) {
      state.subContentVideoPlay = value;
    },
    bgValue(state, value) {
      state.bgValue = value;
    },
    s0(state, value) {
      state.s0 = value;
    },
    s1(state, value) {
      state.s1 = value;
    },
    s2(state, value) {
      state.s2 = value;
    },
    s3(state, value) {
      state.s3 = value;
    },
    s4(state, value) {
      state.s4 = value;
    },
    s5(state, value) {
      state.s5 = value;
    },
    s6(state, value) {
      state.s6 = value;
    },
    menuActive(state, value) {
      state.menuActive = value;
    },
    showSubContent(state, value) {
      state.showSubContent = value;
    },
    contentActive (state) {
      state.contentActive = true;
    },
    contentNotActive (state) {
      state.contentActive = false;
    },
    subContentActive(state) {
      state.subContentActive = true;
    },
    subContentNotActive(state) {
      state.subContentActive = false;
    },
    resetMoveLeft(state) {
      state.subContentMoveLeft = 0;
    },
    moveLeft(state) {
      state.subContentMoveLeft -= window.innerWidth;
    },
    moveRight(state) {
      state.subContentMoveLeft += window.innerWidth;
    },
    goToSlide(state, value) {
      state.subContentMoveLeft = -window.innerWidth * value;
    },
    setMoveLeftValue(state, value) {
      state.subContentMoveLeft = value;
    },
    closeContentTrue(state) {
      state.closeContentActive = true;
    },
    closeContentFalse(state) {
      state.closeContentActive = false;
    },
    currentSlide(state, slide) {
      state.subContentContainerValues.currentSlide = slide;
    },
    currentOffset(state, offset) {
      state.subContentContainerValues.offset = offset;
    },
    currentMainSection(state, section) {
      state.siteContainerValues.currentSection = section;
    },
    currentMainOffset(state, offset) {
      state.siteContainerValues.offset = offset;
    },
    currentMainOffsetSubtract(state, offset) {
      state.siteContainerValues.offset -= offset;
    },
    currentMainOffsetAdd(state, offset) {
      state.siteContainerValues.offset += offset;
    }
  },
  actions: {
    refresh() {
      window.location.reload(true);
    },
    checkSize({ state }) {
      if (window.innerWidth > 992) {
        state.size.isDesktop = true;
        state.size.isTablet = false;
        state.size.isMobile = false;
        state.baseFontSize = 18;
      } else if (window.innerWidth <= 992 && window.innerWidth >= 768) {
        state.size.isDesktop = false;
        state.size.isTablet = true;
        state.size.isMobile = false;
        state.baseFontSize = 18;
      } else if (window.innerWidth < 768) {
        state.size.isDesktop = false;
        state.size.isTablet = false;
        state.size.isMobile = true;
        state.baseFontSize = 16;
      }
    },
    setFloatingButtonPos(context, baseFont) {
      const floatingButtonRight = document.querySelectorAll('.floating-button.is--right');
      const floatingButtonCenter = document.querySelectorAll('.floating-button.is--center');
      const fixPosRight = (15 / baseFont) * baseFont;
      const sectionButtons = document.querySelectorAll('.go-to-section');

      for (let i = 0; i < floatingButtonRight.length; i += 1) {
        const buttonWidth = floatingButtonRight[i].offsetWidth;
        const leftPos = window.innerWidth - buttonWidth - fixPosRight;

        floatingButtonRight[i].style.left = `${leftPos}px`;
      }

      for (let i = 0; i < floatingButtonCenter.length; i += 1) {
        // const buttonWidth = floatingButtonCenter[i].offsetWidth;
        const centerPos = (window.innerWidth / 2);

        floatingButtonCenter[i].style.left = `${centerPos}px`;
        // floatingButtonCenter[i].style.marginLeft = `-${buttonWidth / 2}px`;
      }

      for (let k = 0; k < sectionButtons.length; k += 1) {
        sectionButtons[k].style.top = `${window.innerHeight - 100}px`;
      }
    },
    applySizeSections(context) {
      const sectionContainer = document.querySelectorAll('.section__container');
      const sections = document.querySelectorAll('.section');
      const sectionWidth = window.innerWidth;
      const fullSections = document.querySelectorAll('.full-block');
      const menuContainer = document.querySelector('.menu__container');
      const videoContent = document.querySelectorAll('video');

      if (window.innerWidth < 767) {
        menuContainer.style.height = `${window.innerHeight}px`;
        menuContainer.style.width = `${window.innerWidth}px`;
      } else {
        menuContainer.style.height = 'auto';
        menuContainer.style.width = 'auto';
        // menuContainer.style.opacity = '1';
      }

      for (let i = 0; i < sections.length; i += 1) {
        const id = sectionContainer[i].getAttribute('data-id');
        const fullBlockSections = document.querySelectorAll(`.section[data-id='${id}'] .full-block`);
        const childCount = fullBlockSections.length;
        const sectionOffset = sectionContainer[i].offsetTop;

        sections[i].style.height = `${window.innerHeight}px`;
        sections[i].style.width = `${sectionWidth * childCount}px`;
      }

      for (let ii = 0; ii < fullSections.length; ii += 1) {
        fullSections[ii].style.height = `${window.innerHeight}px`;
        fullSections[ii].style.width = `${window.innerWidth}px`;
      }

      for (let j = 0; j < videoContent.length; j += 1) {
        videoContent[j].style.minHeight = `${window.innerHeight}px`;
        videoContent[j].style.minWidth = `${window.innerWidth}px`;
      }
    },
    applyBgSize(context) {
      // NOTE: applyBgSize()
      const bgImages = document.querySelectorAll('.page-background__container img');

      imagesLoaded(bgImages, function () {
        for (let j = 0; j < bgImages.length; j += 1) {
          // console.log(j, bgImages[j].offsetWidth);
          if (window.innerWidth > 768 && !isMobile('all')) {
            // bgImages[j].style.height = `${window.innerHeight}px`;
            // bgImages[j].classList.add('js-zoom'); disabled requested

            bgImages[j].style.height = `${window.innerHeight}px`;
            bgImages[j].style.width = 'auto';
            bgImages[j].style.top = '0';

            // if (bgImages[j].offsetWidth < window.innerWidth) {
            //   bgImages[j].style.height = 'auto';
            //   bgImages[j].style.width = `${window.innerWidth}px`;
            // } else if (bgImages[j].offsetWidth >= window.innerWidth) {
            //   bgImages[j].style.height = `${window.innerHeight}px`;
            //   bgImages[j].style.width = 'auto';
            //   bgImages[j].style.top = '0';
            // }
          }

          if (isMobile('all')) {
            // setting image size for mobile
            if (window.innerWidth <= 768 && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-6') {
              // to fix some images that are width shorter when height is applied
              // console.log(bgImages[j], bgImages[j].offsetWidth / 2);
              if (bgImages[j].offsetWidth / 2 < window.innerWidth && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-2' && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-1' &&
              bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-4') {
                bgImages[j].style.width = `${window.innerWidth}px`;
                bgImages[j].style.height = 'auto';
                bgImages[j].style.minHeight = 'auto';
              } else {
                bgImages[j].style.height = `${window.innerHeight}px`;
                bgImages[j].style.width = 'auto';
                bgImages[j].style.minWidth = 'auto';
              }
            }

            // if (bgImages[j].offsetWidth > bgImages[j].offsetHeight) {
            //   bgImages[j].style.height = `${window.innerHeight}px`;
            //   bgImages[j].style.width = 'auto';
            //   bgImages[j].style.minWidth = 'auto';
            // } else {
            //   bgImages[j].style.width = `${window.innerWidth}px`;
            //   bgImages[j].style.height = 'auto';
            //   bgImages[j].style.minHeight = 'auto';
            // }

            if (bgImages[j].offsetWidth <= window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') || bgImages[j].parentNode.parentNode.getAttribute('class') === 'cover-6') {
              // bgImages[j].classList.add('js-zoom'); disabled requested
            } else if (bgImages[j].offsetWidth > window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') && !bgImages[j].classList.contains('js-zoom')
            && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-6') {
              if (window.innerWidth < 768) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  bgImages[j].classList.add('js-pan');
                  bgImages[j].style.height = `${window.innerHeight}px`;
                  bgImages[j].style.width = 'auto';
                }
              } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  // console.log(bgImages[j].parentNode.getAttribute('data-id'));
                  bgImages[j].classList.add('js-pan');
                  bgImages[j].style.height = `${window.innerHeight}px`;
                  bgImages[j].style.width = 'auto';
                }
              }
            }
          }

          const leftValue = Math.abs((bgImages[j].offsetWidth - window.innerWidth) / 2);
          const topValue = Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2);

          if (bgImages[j].classList.contains('js-zoom')) {
            if (bgImages[j].offsetWidth >= window.innerWidth) {
              bgImages[j].style.left = 0;

              if (window.innerWidth >= 768) {
                // console.log(Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2));
                bgImages[j].style.top = `${Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2)}px`;
              }
            } else {
              bgImages[j].style.left = `${leftValue}px`;
            }

            if (window.innerWidth < 768) {
              bgImages[j].style.top = '0px';
            }
          }
        }
      });
    },
    applyResizeBgSize:
      debounce(function (context) {
      /* NOTE: applyResizeBgSize() Resize for bg image
      [ ]
      */
      const bgImages = document.querySelectorAll('.page-background__container img');
      const activeBgImage = document.querySelector('.page-background__container .show img');

      imagesLoaded(bgImages, function() {
        for (let j = 0; j < bgImages.length; j += 1) {
          // console.log(j, bgImages[j].offsetWidth);
          if (window.innerWidth >= 768 && !bgImages[j].parentNode.classList.contains('has--video') && !isMobile('all')) {
            // bgImages[j].classList.add('js-zoom'); disabled requested
            bgImages[j].classList.remove('js-pan');
          }

          // if (bgImages[j].classList.contains('js-zoom')) {
          //   if (window.innerWidth >= 768) {
          //     if (bgImages[j].offsetWidth < window.innerWidth) {
          //       bgImages[j].style.height = 'auto';
          //       bgImages[j].style.width = `${window.innerWidth}px`;
          //     } else if (bgImages[j].offsetWidth > window.innerWidth) {
          //       bgImages[j].style.height = `${window.innerHeight}px`;
          //       bgImages[j].style.width = 'auto';
          //     }
          //     bgImages[j].style.top = '0';
          //   }
          // }

          const leftValue = Math.abs((bgImages[j].offsetWidth - window.innerWidth) / 2);
          const topValue = Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2);

          if (window.innerWidth >= 768) {
            if (bgImages[j].offsetWidth > window.innerWidth) {
              bgImages[j].style.left = `-${leftValue}px`;

              if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6') {
              } else if (bgImages[j].parentNode.getAttribute('data-id') === 'cover-2-2' && isMobile('all') && (window.innerWidth >= 768 && window.innerWidth < 1024)) {
                bgImages[j].style.left = '-600px';
              } else if (bgImages[j].parentNode.getAttribute('data-id') === 'cover-2-6' && isMobile('all') && (window.innerWidth >= 768 && window.innerWidth < 1024)) {
                bgImages[j].style.left = '-700px';
              }
            } else {
              bgImages[j].style.left = `${leftValue}px`;
            }
          }

          // setting mobile parameters
          if (isMobile('all')) {
            if (bgImages[j].offsetWidth <= window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') || bgImages[j].parentNode.parentNode.getAttribute('class') === 'cover-6') {
              // bgImages[j].classList.add('js-zoom'); disabled requested
              bgImages[j].classList.remove('js-pan');

              if (bgImages[j].offsetWidth > window.innerWidth) {
                bgImages[j].style.left = `-${leftValue}px`;
              } else {
                // bgImages[j].style.left = `${leftValue}px`;
                // bgImages[j].style.width = `${window.innerWidth}px`;
                // bgImages[j].style.height = 'auto';
                // bgImages[j].style.left = '0';
              }
            } else if (bgImages[j].offsetWidth > window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') && bgImages[j].parentNode.parentNode.getAttribute('data-id') !== 'cover-6') {

              if (window.innerWidth < 768) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  bgImages[j].classList.add('js-pan');
                  // bgImages[j].classList.remove('js-zoom'); disabled requested
                  bgImages[j].style.height = `${window.innerHeight}px`;
                  bgImages[j].style.width = 'auto';
                  bgImages[j].style.transform = 'scale(1)';
                }
              } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  // console.log(`jjj ${bgImages[j].parentNode.getAttribute('data-id')}`);
                  bgImages[j].classList.add('js-pan');
                  // bgImages[j].classList.remove('js-zoom'); disabled requested
                  bgImages[j].style.height = `${window.innerHeight}px`;
                  bgImages[j].style.width = 'auto';
                  bgImages[j].style.transform = 'scale(1)';
                }
              }

              if (bgImages[j].classList.contains('js-pan')) {
                if (!bgImages[j].classList.contains('animate')) {
                  bgImages[j].style.left = '0';
                } else {
                  bgImages[j].style.left = `-${leftValue}px`;
                }
              }

              // if (bgImages[j].getAttribute('data-pan') === 'left-to-right' && !bgImages[j].classList.contains('animate')) {
              //   bgImages[j].style.left = '0';
              // } else if (bgImages[j].getAttribute('data-pan') === 'left-to-right' && bgImages[j].classList.contains('animate')) {
              //   const computedStyle = window.getComputedStyle(activeBgImage);
              //   bgImages[j].style.left = computedStyle.getPropertyValue('left');
              // } else {
              //   bgImages[j].style.left = 'auto';
              // }

              if (bgImages[j].getAttribute('data-pan') === 'right-to-left') {
                bgImages[j].style.left = 'auto';
              }
            }
          }
        }
      });
    }, 300),
    setFullBlockFloatingButtonPos(context, baseFont) {
      const floatingButtonRight = document.querySelectorAll('.section__container.is--active .floating-button.is--right');
      const floatingButtonCenter = document.querySelectorAll('.section__container.is--active .floating-button.is--center');
      const fixPosRight = (15 / baseFont) * baseFont;

      for (let i = 0; i < floatingButtonRight.length; i += 1) {
        const buttonWidth = floatingButtonRight[i].offsetWidth;
        const leftPos = window.innerWidth - buttonWidth - fixPosRight;

        floatingButtonRight[i].style.left = `${leftPos}px`;
      }

      for (let i = 0; i < floatingButtonCenter.length; i += 1) {
        const buttonWidth = floatingButtonCenter[i].offsetWidth;
        const centerPos = (window.innerWidth / 2);

        floatingButtonCenter[i].style.left = `${centerPos}px`;
        // floatingButtonCenter[i].style.marginLeft = `-${buttonWidth / 2}px`;
      }
    },
    applySizeFullBlockSections(context) {
      const sectionContainer = document.querySelector('.section__container.is--active');
      const section = document.querySelector('.section__container.is--active .section');
      const sectionWidth = window.innerWidth;
      const fullBlockSections = document.querySelectorAll('.section__container.is--active .section .full-block');
      const childCount = fullBlockSections.length;

      section.style.height = `${window.innerHeight}px`;
      section.style.width = `${sectionWidth * childCount}px`;

      for (let ii = 0; ii < fullBlockSections.length; ii += 1) {
        fullBlockSections[ii].style.height = `${window.innerHeight}px`;
        fullBlockSections[ii].style.width = `${window.innerWidth}px`;
      }
    },
    activeMenuItem(context, index) {
      const item = document.querySelector('.menu__container li.is--active');
      const activeItem = document.querySelector(`.menu__container li[data-index="${index}"]`);

      item.classList.remove('is--active');
      activeItem.classList.add('is--active');
    },
    zoomEffect(context, status) {
      /* NOTE: zoomInEffect()
      [x] Apply zoom in from 95% - 100% (width)
      */
      const activeBgImage = document.querySelector('.page-background__container .show');
      const baseTiming = 15;
      const baseScale = 1000;
      const scale = 1.2;
      const duration = `${(baseTiming / baseScale) * Math.round(window.innerWidth * scale)}`;
      const isPlayed = activeBgImage.children[0].classList.contains('is--played');

      if (activeBgImage.children[0].classList.contains('js-zoom')) {
        activeBgImage.children[0].classList.add('animate');

        if (status) {
          // pause previous zoom element
          const mainImageClass = activeBgImage.parentNode.getAttribute('class');
          const mainImage = document.querySelector(`.page-background__container [data-id='${mainImageClass}-0']`);

          if (mainImage.children[0].nodeName !== 'VIDEO') {
            if (document.querySelector('.page-background__container img.js-zoom--pause')) {
              const prevBgImage = document.querySelector('.page-background__container img.js-zoom--pause');
              const computedStyle = window.getComputedStyle(prevBgImage);
              const transformMatrix = computedStyle.getPropertyValue('transform');

              prevBgImage.style.transform = transformMatrix;
              prevBgImage.style.transitionDuration = '0s';
              prevBgImage.classList.remove('animate');
              prevBgImage.classList.remove('js-zoom--pause');
            }
          }

          // if pan is prev active bg, pause it
          if (document.querySelector('.page-background__container img.js-pause')) {
            const prevBgImage = document.querySelector('.page-background__container img.js-pause');
            const prevPan = prevBgImage.getAttribute('data-pan');
            const computedStyle = window.getComputedStyle(prevBgImage);

            if (prevPan === 'left-to-right') {
              const left = computedStyle.getPropertyValue('left');
              prevBgImage.style.left = left;
            } else if (prevPan === 'right-to-left') {
              const right = computedStyle.getPropertyValue('right');
              prevBgImage.style.right = right;
            }

            prevBgImage.style.transitionDuration = '0s';
            prevBgImage.classList.remove('animate');
            prevBgImage.classList.remove('js-pause');
          }
        }

        activeBgImage.children[0].style.transitionDuration = `${duration}s`;
        activeBgImage.children[0].style.transform = `scale(${scale})`;
      }
    },
    zoomEffectClose({commit, state}, context) {
      /* NOTE: zoomEffectClose()
      [x] Zoom out on close
      */
      const activeBgImage = document.querySelector('.page-background__container img.js-zoom.animate');
      const computedStyle = window.getComputedStyle(activeBgImage);
      const allZoomItems = document.querySelectorAll(`.page-background__container .cover-${state.siteContainerValues.currentSection} img.js-zoom`);
      const mainBgImage = allZoomItems[0];
      const transformMatrix = computedStyle.getPropertyValue('transform');

      const baseTiming = 5;
      const baseScale = 1000;
      const scale = 1;
      const duration = `${(baseTiming / baseScale) * Math.round(window.innerWidth * scale)}`;

      // pause zoom on current active bg
      activeBgImage.style.transform = transformMatrix;

      // add zoom out effect on bg image if on first image
      if (mainBgImage.classList.contains('js-zoom') && mainBgImage.classList.contains('animate')) {
        activeBgImage.style.transitionDuration = `${duration}s`;
        activeBgImage.style.transitionTimingFunction = 'ease';
        activeBgImage.style.transform = `scale(${scale})`;

        setTimeout(() => {
          activeBgImage.classList.remove('is--played');
          activeBgImage.style.transitionTimingFunction = 'linear';
          activeBgImage.style.transform = 'scale(1)';
          activeBgImage.style.transitionDuration = '0s';
          activeBgImage.classList.remove('animate');
        }, state.timing.closeContentDelay);

        // reset values for all other images
        for (let i = 1; i < allZoomItems.length; i += 1) {
          allZoomItems[i].classList.remove('is--played');
          allZoomItems[i].style.transitionDuration = '0s';
          allZoomItems[i].style.transform = 'scale(1)';
        }
      } else {
        activeBgImage.classList.remove('animate');

        setTimeout(() => {
          for (let i = 1; i < allZoomItems.length; i += 1) {
            allZoomItems[i].classList.remove('is--played');
            allZoomItems[i].style.transform = 'scale(1)';
            allZoomItems[i].style.transitionDuration = '0s';
          }
        }, state.timing.closeContentDelay);

        // reset first image
        allZoomItems[0].style.transform = 'scale(1)';
        allZoomItems[0].style.transitionDuration = '0s';
      }
    },
    panEffect(context, status) {
      /* NOTE: panEffect() - for mobile
      [x] Pan from left to right
      [x] Pan from right to left
      [x] Calculate duration timing
      [x] Apply pan direction style
      [x] Stop panning when not in view
      */

      if (isMobile('all')) {
        const activeBgImage = document.querySelector('.page-background__container .show');
        const activePan = activeBgImage.children[0].getAttribute('data-pan');
        const distance = Math.round(activeBgImage.children[0].offsetWidth - window.innerWidth);
        const baseTiming = 30;
        const baseDistance = 1000;
        const timingDelay = 1;
        let updateDistance = '';
        const isPlayed = activeBgImage.children[0].classList.contains('is--played');

        if (activeBgImage.children[0].classList.contains('js-pan')) {
          activeBgImage.children[0].classList.add('animate');
        }

        if (status) {
          // pause previous pan element
          if (document.querySelector('.page-background__container img.js-pause')) {
            const prevBgImage = document.querySelector('.page-background__container img.js-pause');
            const prevPan = prevBgImage.getAttribute('data-pan');
            const computedStyle = window.getComputedStyle(prevBgImage);

            if (prevPan === 'left-to-right') {
              const left = computedStyle.getPropertyValue('left');
              prevBgImage.style.left = left;
            } else if (prevPan === 'right-to-left') {
              const right = computedStyle.getPropertyValue('right');
              prevBgImage.style.right = right;
            }

            prevBgImage.style.transitionDuration = '0s';
            prevBgImage.classList.remove('animate');
            prevBgImage.classList.remove('js-pause');
          }
        }

        // pause previous zoom element
        // if (document.querySelector('.page-background__container img.js-zoom--pause')) {
        //   const prevBgImage = document.querySelector('.page-background__container img.js-zoom--pause');
        //   const computedStyle = window.getComputedStyle(prevBgImage);
        //   const transformMatrix = computedStyle.getPropertyValue('transform');
        //
        //   prevBgImage.style.transform = transformMatrix;
        //   prevBgImage.style.transitionDuration = '0s';
        //   prevBgImage.classList.remove('animate');
        //   prevBgImage.classList.remove('js-zoom--pause');
        // }

        if (!isPlayed && activeBgImage.children[0].classList.contains('js-pan')) {
          activeBgImage.children[0].style.transitionDuration = `${(baseTiming / baseDistance) * distance}s`;
        } else if (isPlayed && activeBgImage.children[0].classList.contains('js-pan')){
          if (activePan === 'left-to-right') {
            const pausedLeft = parseInt(activeBgImage.children[0].style.left);
            // console.log(pausedLeft);
            updateDistance = distance - Math.abs(parseInt(pausedLeft));
          } else if (activePan === 'right-to-left') {
            const pausedRight = parseInt(activeBgImage.children[0].style.right);
            // console.log(pausedRight);
            updateDistance = distance - Math.abs(parseInt(pausedRight));
          }
          activeBgImage.children[0].style.transitionDuration = `${(((baseTiming / baseDistance) * distance) / distance) * updateDistance}s`;
        }
        // console.log(`duration: ${(baseTiming / baseDistance) * distance}s Base distance: ${distance} Actual Distance: ${updateDistance} Adjusted duration: ${(((baseTiming / baseDistance) * distance) / distance) * updateDistance}s`);

        if (activeBgImage.children[0].classList.contains('js-pan')) {
          if (activePan === 'left-to-right') {
            activeBgImage.children[0].style.left = `-${distance}px`;
          } else if (activePan === 'right-to-left') {
            activeBgImage.children[0].style.right = `-${distance}px`;
          }
        }

        if (activeBgImage.children[0].nodeName === 'VIDEO') {
          if (status) {
            // pause previous pan element
            if (document.querySelector('.page-background__container img.js-pause')) {
              const prevBgImage = document.querySelector('.page-background__container img.js-pause');
              const prevPan = prevBgImage.getAttribute('data-pan');
              const computedStyle = window.getComputedStyle(prevBgImage);

              if (prevPan === 'left-to-right') {
                const left = computedStyle.getPropertyValue('left');
                prevBgImage.style.left = left;
              } else if (prevPan === 'right-to-left') {
                const right = computedStyle.getPropertyValue('right');
                prevBgImage.style.right = right;
              }

              prevBgImage.style.transitionDuration = '0s';
              prevBgImage.classList.remove('animate');
              prevBgImage.classList.remove('js-pause');
            }
          }
        }
      }
    },
    panEffectClose({commit, state}, context) {
      // NOTE: panEffectClose()
      const currentSlide = state.subContentContainerValues.currentSlide;
      const currentSection = state.siteContainerValues.currentSection;
      const activeBgImage = document.querySelector(`.page-background__container [data-id="cover-${currentSection}-${currentSlide}"] img`);
      const mainBgImage = document.querySelector('.page-background__container .show img');
      const allPanItems = document.querySelectorAll(`.page-background__container .cover-${state.siteContainerValues.currentSection} img.js-pan`);

      // to reset main bg image
      if (mainBgImage.classList.contains('js-pan') && !mainBgImage.classList.contains('animate')) {
        if (mainBgImage.getAttribute('data-pan') === 'left-to-right') {
          mainBgImage.style.left = '0px';
        } else {
          mainBgImage.style.right = '0px';
        }
        mainBgImage.style.transitionDuration = '0s';
        mainBgImage.classList.remove('is--played');
      }

      // console.log(currentSlide, currentSection, activeBgImage, mainBgImage);

      if (activeBgImage.classList.contains('js-pan')) {
        const activePan = activeBgImage.getAttribute('data-pan');
        const computedStyle = window.getComputedStyle(activeBgImage);

        if (activePan === 'left-to-right') {
          const left = computedStyle.getPropertyValue('left');
          activeBgImage.style.left = left;
        } else if (activePan === 'right-to-left') {
          const right = computedStyle.getPropertyValue('right');
          activeBgImage.style.right = right;
        }

        activeBgImage.style.transitionDuration = '0s';
        activeBgImage.classList.remove('animate');

        setTimeout(() => {
          for (let i = 1; i < allPanItems.length; i += 1) {
            allPanItems[i].classList.remove('is--played');
            if (allPanItems[i].getAttribute('data-pan') === 'left-to-right') {
              allPanItems[i].style.left = '0px';
            } else {
              allPanItems[i].style.right = '0px';
            }
          }
        }, state.timing.closeContentDelay + 300);
      }
    },
    imageEffectResize({commit, state}, context) {
      /* NOTE: imageEffectResize()
      [x] Stop zooming effect while resizing
      [x] Stop panning effect while resizing
      */
      const activeBgImage = document.querySelector('.page-background__container .show');
      const computedStyle = window.getComputedStyle(activeBgImage);

      if (activeBgImage.classList.contains('js-zoom')) {
        const transformMatrix = computedStyle.getPropertyValue('transform');
        const baseTiming = 5;
        const baseScale = 1000;
        const scale = 1;
        const duration = `${(baseTiming / baseScale) * Math.round(window.innerWidth * scale)}`;

        activeBgImage.style.transform = transformMatrix;
        activeBgImage.style.transitionDuration = '0s';
        activeBgImage.classList.remove('animate');
      } else if (activeBgImage.classList.contains('js-pan')) {
        const activePan = activeBgImage.getAttribute('data-pan');

        activeBgImage.classList.add('is--played');
        activeBgImage.style.transitionDuration = '0s';
        activeBgImage.classList.remove('animate');

        if (activePan === 'left-to-right') {
          const left = computedStyle.getPropertyValue('left');
          activeBgImage.style.left = left;
        } else if (activePan === 'right-to-left') {
          const right = computedStyle.getPropertyValue('right');
          activeBgImage.style.right = right;
        }

      }
    },
    stopAudio({commit, state}, context) {
      // NOTE: stopAudio()
      const music = document.getElementById('bg-music');
      const soundButton = document.querySelector('.social__item.is--sound');

      commit('audioPlaying', false);

      stopMusic();

      soundButton.children[0].classList.remove('animate');

      anime({
        targets: soundButton,
        opacity: 0.3,
        easing: 'easeOutSine',
        duration: 200,
      });
    },
    startAudio({commit, state}, context) {
      // NOTE: startAudio()
      const music = document.getElementById('bg-music');
      const soundButton = document.querySelector('.social__item.is--sound');

      commit('audioPlaying', true);

      startMusic();

      soundButton.children[0].classList.add('animate');

      anime({
        targets: soundButton,
        opacity: 1,
        easing: 'easeOutSine',
        duration: 200,
      });
    },
    strokeZoom({commit, state}, context) {
      const strokeCanvas = document.getElementById('coverCanvas');

      if (!state.strokeStatus) {
        enterCover();
        commit('strokeStatus', true);
      } else {
        leaveCover();
        commit('strokeStatus', false);
      }
    },
    videoHandler: debounce(function ({commit, state}, context) {
      /* NOTE: videoHandler() main cover handler
      */

      if (state.playsinline) {
        const currentSection = state.siteContainerValues.currentSection;
        const activeVideo = document.querySelector(`.page-background__container .cover-${state.siteContainerValues.currentSection} video`);

        if (document.querySelector(`.cover-${state.siteContainerValues.currentSection} .main-content-item`).children[0].nodeName === 'VIDEO') {
          activeVideo.play();
        }
      }
    }, 500),
    getBgValue({ commit, state }, value) {
      switch (value) {
        case 0:
          commit('bgValue', state.s0);
          break;
        case 1:
          commit('bgValue', state.s1);
          break;
        case 2:
          commit('bgValue', state.s2);
          break;
        case 3:
          commit('bgValue', state.s3);
          break;
        case 4:
          commit('bgValue', state.s4);
          break;
        case 5:
          commit('bgValue', state.s5);
          break;
        case 6:
          commit('bgValue', state.s6);
          break;
        default:
          commit('bgValue', 0);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/store.js